export default [
  [
    {
      Icon: 'mdi-bell',
      TitleKey: 'screens.events.title',
      RouteName: 'dashboard.events'
    },
    {
      Icon: 'mdi-counter',
      TitleKey: 'screens.counters.title',
      RouteName: 'dashboard.account.mycounters',
      Permission: 'accounts.view'
    }
  ],
  [
    {
      Icon: 'mdi-gauge',
      TitleKey: 'screens.models.title',
      RouteName: 'dashboard.types',
      Permission: 'models.view'
    },
    {
      Icon: 'mdi-water',
      TitleKey: 'screens.providers.title',
      RouteName: 'dashboard.providers',
      Permission: 'providers.view'
    },
    {
      Icon: 'mdi-home-group',
      TitleKey: 'screens.companies.title',
      RouteName: 'dashboard.companies',
      Permission: 'companies.view'
    },
    {
      Icon: 'mdi-home-city',
      TitleKey: 'screens.buildings.title',
      RouteName: 'dashboard.buildings',
      Permission: 'buildings.view'
    }
  ],
  [
    {
      Icon: 'mdi-shield-account',
      TitleKey: 'screens.permissions.title',
      RouteName: 'dashboard.permissions',
      Permission: 'permission.edit'
    },
    {
      Icon: 'mdi-account',
      TitleKey: 'screens.users.title',
      RouteName: 'dashboard.users',
      Permission: 'users.view'
    }
  ]
];
